var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6382 3.69487C13.3124 3.36893 12.9256 3.11036 12.4999 2.93396C12.0741 2.75755 11.6178 2.66675 11.1569 2.66675C10.6961 2.66675 10.2397 2.75755 9.814 2.93396C9.38825 3.11036 9.00143 3.36893 8.67564 3.69487L7.9995 4.37101L7.32337 3.69487C6.66529 3.03679 5.77274 2.66709 4.84208 2.66709C3.91142 2.66709 3.01887 3.03679 2.36079 3.69487C1.70271 4.35295 1.33301 5.2455 1.33301 6.17616C1.33301 7.10682 1.70271 7.99937 2.36079 8.65745L3.03693 9.33358L7.9995 14.2962L12.9621 9.33358L13.6382 8.65745C13.9642 8.33166 14.2227 7.94484 14.3991 7.51909C14.5755 7.09334 14.6663 6.63701 14.6663 6.17616C14.6663 5.71531 14.5755 5.25898 14.3991 4.83323C14.2227 4.40748 13.9642 4.02067 13.6382 3.69487V3.69487Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeart;